(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Posts the newsletter without a page load.
  //
  // PROGRESSIVE ENHANCEMENT, and the fallback is the point: the form posts natively on
  // its own, so with this script blocked or broken a shopper still subscribes and still
  // sees the result — they just get a page load doing it. Nothing here is required for
  // the form to work, and anything unexpected hands the submit back to the browser.
  //
  // IT HOLDS NO ENGLISH. Shopify answers a post with the whole page re-rendered, which
  // already contains this form's own success or error markup, built by the Liquid above
  // from the locale file and Shopify's localized `default_errors`. So the script lifts
  // that node out of the response and drops it into the live region rather than carrying
  // its own strings — the same reason no other module in this theme holds a word of copy.
  (() => {
    const wire = (scope) => {
      const form = scope.querySelector('.footer__subscribe-form');
      if (!form || form.dataset.wired === 'true') return;
      form.dataset.wired = 'true';

      const status = form.querySelector('.footer__subscribe-status');
      const input = form.querySelector('.footer__subscribe-input');
      const submit = form.querySelector('.footer__subscribe-submit');
      if (!status) return;

      form.addEventListener('submit', async (event) => {
        // The browser's own validation speaks first. Letting the event through when the
        // field is invalid is what shows the native bubble on an empty or malformed
        // address, and it costs no request.
        if (!form.checkValidity()) return;

        event.preventDefault();
        form.setAttribute('aria-busy', 'true');
        if (submit) submit.disabled = true;

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' },
          });

          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const message = parsed.querySelector('.footer__subscribe-status > *');

          // Shopify puts bot protection on this endpoint and answers with a verification
          // page when it wants one, and that page carries no form of ours. Posting
          // natively hands the shopper the challenge so they can finish, which is better
          // than reporting a failure they cannot act on.
          if (!message) {
            form.submit();
            return;
          }

          status.replaceChildren(document.importNode(message, true));

          const ok = message.classList.contains('footer__subscribe-message--success');
          if (input) {
            if (ok) {
              input.value = '';
              input.removeAttribute('aria-invalid');
            } else {
              input.setAttribute('aria-invalid', 'true');
            }
          }
        } catch {
          // Offline, or the request never landed. The native post either works or shows
          // the browser's own error, both of which beat a silent dead button.
          form.submit();
        } finally {
          form.removeAttribute('aria-busy');
          if (submit) submit.disabled = false;
        }
      });
    };

    const wireAll = () => document.querySelectorAll('.section-footer').forEach(wire);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll, { once: true });
    } else {
      wireAll();
    }

    // The theme editor re-renders a section in place, which drops the old listener.
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target.classList?.contains('section-footer')
        ? event.target
        : event.target.querySelector?.('.section-footer');
      if (scope) wire(scope);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Drives the header's State=Onscroll. Watches the sentinel rather than listening to
  // scroll, so there is no per-frame work and no scroll-offset constant.
  (() => {
    const wire = (scope) => {
      const header = scope.querySelector('.header');
      // The sentinel lives in layout/theme.liquid, above this section — see the note
      // there. It is outside `scope` by design.
      const sentinel = document.querySelector('.header-sentinel');

      if (!header || !sentinel || header.dataset.wired === 'true') return;
      header.dataset.wired = 'true';

      // Not sticky means nothing shrinks, so leave the rest state in place.
      if (header.dataset.sticky !== 'true') return;

      new IntersectionObserver(
        ([entry]) => {
          header.dataset.scrolled = String(!entry.isIntersecting);
        },
        { threshold: 0 }
      ).observe(sentinel);
    };

    // A link in the drawer has to close it. The panel covers the screen, so a shopper
    // who taps "faq" would otherwise watch the page scroll behind a drawer that is
    // still in the way. Closing on the click is enough — the fragment navigation is the
    // browser's and carries on regardless, and nothing here is scroll-locked. Delegated
    // to the panel, so flavour cards, nav links and the subscriptions button are all
    // covered, and so blocks added later need no wiring.
    const wireDrawer = (scope) => {
      scope.querySelectorAll('.header__drawer').forEach((drawer) => {
        const panel = drawer.querySelector('.header__drawer-panel');
        if (!panel || panel.dataset.wired === 'true') return;
        panel.dataset.wired = 'true';

        // The panel reaches the bottom of the screen, and how far down it starts depends
        // on whether the announcement band is still on screen. Measured on open rather
        // than assumed — one read per toggle, no scroll listener. The CSS falls back to
        // both bands' tokens without this, which is exact at the top of the page.
        drawer.addEventListener('toggle', () => {
          if (!drawer.open) return;
          const bar = drawer.closest('.header');
          if (!bar) return;
          panel.style.setProperty('--drawer-top', `${Math.round(bar.getBoundingClientRect().bottom)}px`);
        });

        panel.addEventListener('click', (event) => {
          if (event.defaultPrevented) return;
          // Only a real destination closes it. A tap on the panel's own padding, or on
          // something that has cancelled its own click, leaves the drawer alone.
          if (!event.target.closest('a[href], button[type="submit"]')) return;
          drawer.open = false;
        });
      });
    };

    const wireAll = () => {
      document.querySelectorAll('.section-header').forEach(wire);
      document.querySelectorAll('.section-header').forEach(wireDrawer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll, { once: true });
    } else {
      wireAll();
    }

    // The theme editor re-renders a section in place, which drops the old observer.
    document.addEventListener('shopify:section:load', (event) => {
      const scope = event.target.classList?.contains('section-header')
        ? event.target
        : event.target.querySelector?.('.section-header');
      if (scope) wire(scope);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
